// extracted by mini-css-extract-plugin
export var dropdownButton = "_1k-0";
export var fullWidthDropdownButton = "_1k-1";
export var icon = "_1k-3";
export var iconPlaceholder = "_1k-2";
export var menuItemRow = "_1k-5";
export var shortcutContainer = "_1k-4";